import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // Correct CSS import for Swiper v8 and beyond
import { Link } from 'react-router-dom';

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Mr. Oliver Carter',
      role: 'CEO',
      image: 'img/rooms/room1.jpg',
    },
   
    {
      name: 'Amma Wilso',
      role: 'Manager',
      image: 'img/rooms/room2.jpg',
    },

    {
      name: 'Sunita Roy',
      role: 'Receptionist',
      image: 'img/rooms/room5.jpg',
    },


    {
      name: 'Nick Tyson',
      role: 'Team Leader',
      image: 'img/rooms/room7.jpg',
    },
// ======================
   
  ];

  return (
    <section className="section-team padding-t-50 padding-b-100">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="rx-banner text-center rx-banner-effects">
              <p>
                <img
                  src="img/banner/left-shape.svg"
                  alt="banner-left-shape"
                  className="svg-img left-side"
                />
                Om Sai PG
                <img
                  src="img/banner/right-shape.svg"
                  alt="banner-right-shape"
                  className="svg-img right-side"
                />
              </p>
              <h4>
                Our <span>Rooms</span>
              </h4>
            </div>
          </div>

          <div className="col-12">
            <Swiper
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 1000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              className="rx-team-slider"
            >
              {teamMembers.map((member, index) => (
                <SwiperSlide key={index}>
                  <div className="rx-team-card">
                    <div className="rx-team-img">
                      <img src={member.image} alt={`team-${index + 1}`} />
                      <div className="rx-team-social-media">
                        {/* <div className="social-media-item">
                          <a href="javascript:void(0)">
                            <i className="ri-facebook-line"></i>
                          </a>
                        </div>
                        <div className="social-media-item">
                          <a href="javascript:void(0)">
                            <i className="ri-instagram-line"></i>
                          </a>
                        </div>
                        <div className="social-media-item">
                          <a href="javascript:void(0)">
                            <i className="ri-linkedin-line"></i>
                          </a>
                        </div>
                        <div className="social-media-item">
                          <a href="javascript:void(0)">
                            <i className="ri-twitter-x-line"></i>
                          </a>
                        </div> */}
                        <p className='text-white'>Om Sai PG</p>
                      </div>
                    </div>
                    <div className="rx-team-contact">
                      {/* <h5>{member.name}</h5>
                      <p>({member.role})</p> */}
                      <Link to='https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking a room at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!!' target="_blank" className='book-btn'>Book Now</Link>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
